module.exports = __webpack_public_path__ + "img/payok.e2338de9.png";